import { lazyRetry } from '@lmt/unicorn-shared/app/helpers/retry-helper';

export const FilterBuilderLazy = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "document-viewer" */ 'devextreme-react/filter-builder'
    ),
);
